import IconHome from '@/assets/IconHome.png';
import IconDashboard from '@/assets/IconDashboard.png';
import IconProjectLocation from '@/assets/IconProjectLocation.png';
import IconComments from '@/assets/IconComments.png';
import IconManageColaborators from '@/assets/IconManageColaborators.png';
import IconMaterialSelection from '@/assets/IconMaterialSelection.png';
import IconAcousticPartitionAndSeparation from '@/assets/IconAcousticPartitionAndSeparation.png';
import IconCarbonImpactEstimator from '@/assets/IconCarbonImpactEstimator.png';

export const architectAreas = [
  {
    id: 'projectInformation',
    titleKey: 'functionalities.projectInfo.name',
    descriptionKey: 'functionalities.projectInfo.description',
    to: '/architect/projectinformation',
    iconSrc: IconProjectLocation
  },
  {
    id: 'materialSelection',
    titleKey: 'functionalities.materialSelection.name',
    descriptionKey: 'functionalities.materialSelection.description',
    to: '/architect/materialselection',
    iconSrc: IconMaterialSelection
  },
  {
    id: 'acousticPartitionAndSeparation',
    titleKey: 'functionalities.acousticPartitionAndSeparation.name',
    descriptionKey: 'functionalities.acousticPartitionAndSeparation.description',
    to: '/architect/acousticpartitionandseparation',
    iconSrc: IconAcousticPartitionAndSeparation
  },
  {
    id: 'carbonImpactEstimator',
    titleKey: 'functionalities.carbonImpactEstimator.name',
    descriptionKey: 'functionalities.carbonImpactEstimator.description',
    to: '/architect/carbonimpactestimator',
    iconSrc: IconCarbonImpactEstimator
  }
];

export const architectNavigationItems = [
  {
    id: 'home',
    titleKey: 'functionalities.projectsListing.name',
    descriptionKey: null,
    to: '/architect',
    iconSrc: IconHome
  },
  {
    id: 'dashboard',
    titleKey: 'views.architect.navigation.dashboard',
    descriptionKey: null,
    to: '/architect/dashboard',
    iconSrc: IconDashboard
  },
  {
    id: 'materialSelection',
    titleKey: 'functionalities.materialSelection.name',
    descriptionKey: 'functionalities.materialSelection.description',
    to: '/architect/materialselection',
    iconSrc: IconMaterialSelection
  },
  {
    id: 'acousticPartitionAndSeparation',
    titleKey: 'functionalities.acousticPartitionAndSeparation.name',
    descriptionKey: 'functionalities.acousticPartitionAndSeparation.description',
    to: '/architect/acousticpartitionandseparation',
    iconSrc: IconAcousticPartitionAndSeparation
  },
  {
    id: 'carbonImpactEstimator',
    titleKey: 'functionalities.carbonImpactEstimator.name',
    descriptionKey: 'functionalities.carbonImpactEstimator.description',
    to: '/architect/carbonimpactestimator',
    iconSrc: IconCarbonImpactEstimator
  },
  {
    id: 'spacer-accounts-2',
    type: 'spacer',
    titleKey: null,
    descriptionKey: null,
    to: null,
    iconSrc: null
  },
  {
    id: 'projectInformation',
    titleKey: 'functionalities.projectInfo.name',
    descriptionKey: null,
    to: '/architect/projectinformation',
    iconSrc: IconProjectLocation
  },
  {
    id: 'comments',
    titleKey: 'views.architect.navigation.comments',
    descriptionKey: null,
    to: '/architect/comments',
    iconSrc: IconComments
  },
  {
    id: 'manageColaborators',
    titleKey: 'views.architect.navigation.manageCollaborators',
    descriptionKey: null,
    to: '/architect/managecolaborators',
    iconSrc: IconManageColaborators
  }
];
